import * as React from "react";
import { LinkTargetType } from "../../../services/playground";
import { transformAParam } from "../../../utils/browser";
import { TextSpan, transformBox } from "./styles";
class ViewMoreCard extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.VMCardBox = transformBox(this.props.StyledComponent);
    }
    render() {
        const { link, isRollable, text, isInApp } = this.props;
        const { VMCardBox } = this;
        const aProps = transformAParam({
            link,
            aTarget: LinkTargetType.Blank,
            isInApp,
        });
        return (React.createElement(VMCardBox, Object.assign({}, aProps, { isRollable: isRollable }),
            React.createElement("img", { style: { width: 32, height: 32 }, src: "https://i.ezbuy.sg/FjFwuX0r1Lw5Z4nb3BfR2uPt3zVY" }),
            React.createElement(TextSpan, null, text || "View More")));
    }
}
export default ViewMoreCard;
